export default "__VITE_ASSET__Dy3p7G75__"